import * as Actions from '../../actions';

const initialState = {
  data: {
    paymentTypes: [],
    workingHours: [],
    shippingAreas: [],
    status: '',
  },
  isLoading: false,
  isLoaded: false,
  error: false,
};

const venue = function (state = initialState, action) {
  switch(action.type) {
    case Actions.GET_VENUE:
    case Actions.GET_VENUE_BY_ID: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        error: false,
      };
    }
    case Actions.GET_VENUE_SUCCESS:
    case Actions.GET_VENUE_BY_ID_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        isLoaded: true,
        error: false,
      };
    }
    case Actions.GET_VENUE_ERROR:
    case Actions.GET_VENUE_BY_ID_ERROR: {
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        error: action.error,
      };
    }

    case Actions.UPDATE_VENUE:
    case Actions.UPDATE_VENUE_STATUSES:
    case Actions.UPDATE_VENUE_STATUSES_WITH_FIREBASE:
    case Actions.UPDATE_VENUE_DELIVERYAREAS:
    case Actions.CONTROL_VENUE_STATUSES: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        error: false,
      };
    }

    case Actions.UPDATE_VENUE_SUCCESS:
    case Actions.UPDATE_VENUE_STATUSES_SUCCESS:
    case Actions.UPDATE_VENUE_STATUSES_WITH_FIREBASE_SUCCESS:
    case Actions.UPDATE_VENUE_DELIVERYAREAS_SUCCESS:
    case Actions.CONTROL_VENUE_STATUSES_SUCCESS: {
      return {
        ...state,
        data: { ...state.data, ...action.payload },
        isLoading: false,
        isLoaded: true,
        error: false,
      };
    }

    case Actions.UPDATE_VENUE_ERROR:
    case Actions.UPDATE_VENUE_STATUSES_ERROR:
    case Actions.UPDATE_VENUE_STATUSES_WITH_FIREBASE_ERROR:
    case Actions.UPDATE_VENUE_DELIVERYAREAS_ERROR:
    case Actions.CONTROL_VENUE_STATUSES_ERROR: {
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        error: action.error,
      };
    }

    // case Actions.LOGOUT: {
    //     return {
    //         ...state,
    //         isLoading: true,
    //         error: false
    //     };
    // }
    // case Actions.LOGOUT_SUCCESS: {
    //     return {
    //         ...state,
    //         data: {
    //             paymentTypes: [],
    //             workingHours: [],
    //             shippingAreas: [],
    //             status: ''
    //         },
    //         isLoading: false,
    //         error: false
    //     }
    // }
    // case Actions.LOGOUT_ERROR: {
    //     return {
    //         ...state,
    //         isLoading: false,
    //         error: action.error
    //     }
    // }
    default: {
      return state;
    }
  }
};

export default venue;
